export default "__VITE_PUBLIC_ASSET__a7327454__"